module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABBNAAAQTQFnjAHgAAABPElEQVRYhe2YwVHDQAxFPwz3uAPSQdxBUgJUADddnQoSOoCjbikhJUAH0EHoIKnAGU3kwWPtWmODgYPezF6k9fp5tTvj3au6rjEWIioArACUAI4A9sx8GD0ggNFCRCQSrwBmndQTM2/NA1MKEdEcwHtCpmHNzM8mOlZIS/EIoDDJC1KmpYl+cQLQJ7TLldYIqYyUYtH3JZ2Xi2AF4MFk89wz876bvU503w6QEQ7ahpKcwRsTueyYhs/Wy8rMmllon1Su4UN3YdH62FvTKzNDbaTWK2m6iHP0yQiVjlGZzEChXyeEPFKLOomugcmJknmEkEcIeYSQRwh5hJBHCHmEkEcIeXi/sBsi2pjohKRmaGci0/CWGtUIMbMIvZieP4ucZO9SI5rLhga9dChN4vscmTl7Cs4K/RX/a5cBOAMaaVLbRdEvxgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_load_transaction.png
// module id = hdag
// module chunks = 4